import { classNames } from '~/utils/styles';
import { FormFieldInformation, Label } from '../..';
import type { FormFieldWrapperProps } from './';

export function FormFieldWrapper({
  htmlFor,
  disabled,
  label,
  required,
  hint,
  information,
  error,
  children,
  optionalText = 'Optional',
  className,
}: FormFieldWrapperProps) {
  return (
    <div className={classNames('width-0 flex flex-col', className)}>
      {(label || !required) && (
        <div className="flex items-end justify-between">
          <Label
            appearance={label instanceof Object ? label?.appearance : undefined}
            disabled={disabled}
            htmlFor={htmlFor}
            position="top"
          >
            {label instanceof Object ? label?.children : label}
          </Label>

          {
            // TODO: Translate
            !required && <div className="body-300-light mb-2 text-neutral-800">{optionalText}</div>
          }
        </div>
      )}

      {children}

      {hint && <div className="body-300-light text-neutral-800">{hint}</div>}
      {information && <FormFieldInformation>{information}</FormFieldInformation>}
      {error && (
        <div className="label-200 py-1 text-red-700" data-form-field-error>
          {error}
        </div>
      )}
    </div>
  );
}
